<script lang="ts">
	import { fade, fly } from "svelte/transition";
	import Fa from "svelte-fa";
	import {
		faCode,
		faCheck,
		faChevronDown,
		faChevronUp,
	} from "@fortawesome/free-solid-svg-icons";

	import { dldl, goto, yyyy, zzzz } from "./store.svelte";

	let engineChoice = (engine: string) => {
		dldl("DevMenu.svelte", `Switching to ${engine}`);
		yyyy.map.engine = engine;
	};

	let closeDevMenu = () => {
		dldl(
			"DevMenu.svelte",
			`closing dev menu with yyyy.dev.isActive = ${yyyy.dev.isActive}`,
		);
		yyyy.dev.showMenu = false;

		// Remove show-dev-menu param from URL and navigate to activate the card
		const url = new URL(window.location.href);
		url.searchParams.delete("show-dev-menu");
		history.replaceState(null, "", url.pathname + url.search);
		goto(url.pathname);
	};

	let showDebugLog = false;
	let isMinimized = false;

	let toggleMinimized = () => {
		isMinimized = !isMinimized;
	};
</script>

<div
	transition:fly|local={{ y: -200 }}
	id="dev-menu"
	class="card"
	class:minimized={isMinimized}
	ondblclick={toggleMinimized}
>
	<div class="card-content">
		{#if !isMinimized}
		<div class="content choices">
			<button
				onclick={() => {
					engineChoice("Maplibre");
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.map.engine === "Maplibre"}
				class:is-light={yyyy.map.engine !== "Maplibre"}
			>
				<span class="icon is-small">
					{#if yyyy.map.engine === "Maplibre"}<Fa icon={faCheck} size="1x" />{/if}
				</span>
				<span>Maplibre</span>
			</button>

			<br />
			<button
				onclick={() => {
					engineChoice("Gleo");
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.map.engine === "Gleo"}
				class:is-light={yyyy.map.engine !== "Gleo"}
			>
				<span class="icon is-small">
					{#if yyyy.map.engine === "Gleo"}<Fa icon={faCheck} size="1x" />{/if}
				</span>
				<span>Gleo</span>
			</button>
			<br />

			<hr />
			<p class="has-text-grey is-size-7 mb-2">Card Map Engine</p>
			<button
				onclick={() => {
					yyyy.map.cardEngine = "Leaflet";
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.map.cardEngine === "Leaflet"}
				class:is-light={yyyy.map.cardEngine !== "Leaflet"}
			>
				<span class="icon is-small">
					{#if yyyy.map.cardEngine === "Leaflet"}<Fa icon={faCheck} size="1x" />{/if}
				</span>
				<span>Leaflet</span>
			</button>
			<br />
			<button
				onclick={() => {
					yyyy.map.cardEngine = "Maplibre";
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.map.cardEngine === "Maplibre"}
				class:is-light={yyyy.map.cardEngine !== "Maplibre"}
			>
				<span class="icon is-small">
					{#if yyyy.map.cardEngine === "Maplibre"}<Fa icon={faCheck} size="1x" />{/if}
				</span>
				<span>Maplibre</span>
			</button>
			<br />

			<button
				onclick={() => {
					yyyy.dev.isActive = !yyyy.dev.isActive;
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.dev.isActive}
				class:is-light={!yyyy.dev.isActive}
			>
				<span class="icon small"> <Fa icon={faCode} /></span>
				<span>Dev Mode</span>
			</button>
			<br />
			<hr />
			<p class="has-text-grey is-size-7 mb-2">Feature Flags</p>
			<button
				onclick={() => {
					if (!yyyy.features) yyyy.features = {};
					yyyy.features.triageAnnotations = !yyyy.features.triageAnnotations;
				}}
				class="button is-fullwidth"
				class:is-primary={yyyy.features?.triageAnnotations}
				class:is-light={!yyyy.features?.triageAnnotations}
			>
				<span class="icon is-small">
					{#if yyyy.features?.triageAnnotations}<Fa icon={faCheck} size="1x" />{/if}
				</span>
				<span>Triage Annotations</span>
			</button>
			<hr />
			<button
				onclick={() => (showDebugLog = !showDebugLog)}
				class="button is-info is-light is-fullwidth"
			>
				<span class="icon is-small">
					<Fa icon={showDebugLog ? faChevronUp : faChevronDown} />
				</span>
				<span>Debug Log</span>
				<span class="icon is-small">
					<Fa icon={showDebugLog ? faChevronUp : faChevronDown} />
				</span>
			</button>

			{#if showDebugLog}
				<div class="debug-log" in:fade={{ duration: 200 }} out:fade={{ duration: 200 }}>
					{#if yyyy.dev.debugLog && yyyy.dev.debugLog.length > 0}
						{#each yyyy.dev.debugLog as logEntry, i}
							<div class="log-entry">
								<span class="tag is-light">#{i}</span>
								<span class="log-content">{logEntry}</span>
							</div>
						{/each}
					{:else}
						<div class="has-text-centered has-text-grey">No debug logs available</div>
					{/if}
				</div>
			{/if}

			<hr />
			<button
				onclick={closeDevMenu}
				class="button is-danger is-light is-outlined is-fullwidth">Close</button
			>
		</div>
		{/if}

		{#if yyyy.map.location}
			<div class="map-info has-text-centered" class:minimized-info={isMinimized}>
				<span class="tag is-info is-light">
					Zoom: {yyyy.map.location.z?.toFixed(2) || 'N/A'}
				</span>
				<span class="tag is-info is-light">
					Center: {yyyy.map.location.coords?.lng?.toFixed(4) || 'N/A'}, {yyyy.map.location.coords?.lat?.toFixed(4) || 'N/A'}
				</span>
				{#if isMinimized}
					<button
						onclick={closeDevMenu}
						class="button is-small is-danger is-light">×</button
					>
				{/if}
			</div>
		{/if}
	</div>
</div>

<style>
	#dev-menu {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		max-width: 875px;
		min-width: 25vw;
		width: 75vw;
		max-height: 75vh;
		overflow-y: auto;
		transition: all 0.3s ease;
	}

	#dev-menu.minimized {
		top: auto;
		bottom: 20px;
		transform: none;
		width: auto;
		min-width: auto;
		max-width: auto;
		max-height: auto;
		overflow: visible;
	}

	.debug-log {
		margin-top: 1rem;
		max-height: 300px;
		overflow-y: auto;
		border: 1px solid #dbdbdb;
		border-radius: 4px;
		background-color: #fafafa;
		padding: 0.5rem;
	}

	.log-entry {
		padding: 0.25rem 0;
		border-bottom: 1px solid #ececec;
		font-family: monospace;
		font-size: 0.875rem;
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.log-entry:last-child {
		border-bottom: none;
	}

	.log-content {
		flex: 1;
		word-break: break-word;
	}

	.map-info {
		background-color: #f0f8ff;
		border-radius: 4px;
		padding: 0.5rem;
		margin: 0.5rem 0;
		display: flex;
		justify-content: center;
		gap: 0.5rem;
	}

	.map-info.minimized-info {
		margin: 0;
		background: transparent;
		padding: 0;
		align-items: center;
	}

	#dev-menu.minimized .card-content {
		padding: 0.75rem;
	}
</style>
